export default {
  title: 'Mon profil',
  tabs: {
    settings: 'Mes paramètres',
    edit: 'Modifier mon profil',
    services: 'Mes services',
    company: 'Mon entreprise',
    achievements: 'Mes réalisations',
    security: 'Authentification et sécurité',
    publicProfile: 'Mon profil public',
    myInfo: 'Mes informations',
  },
  firstName: 'Prénom',
  firstNamePlaceholder: 'Entrez votre prénom',
  lastName: 'Nom',
  lastNamePlaceholder: 'Entrez votre nom',
  city: 'Ville',
  cityPlaceholder: 'Entrez votre ville',
  postalCode: 'Code postal',
  postalCodePlaceholder: 'Entrez votre code postal',
  phone: 'Téléphone',
  phonePlaceholder: 'Entrez votre numéro de téléphone',
  languagesSpoken: 'Langue(s) parlée(s)',
  remoteWork: 'Travaillez-vous à distance',
  yes: 'Oui',
  professionalDescription: 'Décrivez votre pratique professionnelle',
  professionalDescriptionPlaceholder:
    'Décrivez votre expérience professionnelle, vos compétences et ce qui vous rend unique',
  professionalDescriptionNotice:
    'Les coordonnées personnelles ne sont pas permises dans les profils, mais pas de stress, elles sont partagées automatiquement une fois le contact établi sur Pigeons!',
  charactersRemaining: 'caractères restants',
  servicesOffered: 'Services offerts',
  newServicePlaceholder: 'Nouveau service',
  newDescriptionPlaceholder: 'Description (optionnel)',
  serviceNotFoundHint: "Vous n'avez pas trouvé votre service ? Ajoutez-le",
  servicesHint: 'Ajouter un autre service',
  serviceAddedSuccess: 'Nouveau service ajouté avec succès !',
  serviceAddError: "Erreur lors de l'ajout du service. Veuillez réessayer.",
  fieldRequired: 'Ce champ est requis.',
  profileUpdateError: 'Erreur lors de la mise à jour du profil. Veuillez réessayer.',
  profileUpdateSuccess: 'Profil mis à jour avec succès !',
  saving: 'Enregistrement...',
  achievements: {
    projectName: 'Nom du projet',
    serviceOffered: 'Service offert',
    uploadImage: 'Téléverser une photo de profil',
    add: 'Ajouter les réalisations',
    save: 'Enregistrer',
    imageFormatAllowed:
      'Les formats acceptés sont .jpeg et .png. L’affichage est au format carré (1:1).',
    imageUploadHint: 'Cliquez ici pour ajouter une image',
    achievementUploadHint: 'Cliquez ici pour ajouter une réalisation',
    maxFiles: 'Vous pouvez téléverser au maximum 5 fichiers.',
    fileAdded: 'fichier ajouté',
    currentImage: 'Image actuelle',
    removeImage: "Supprimer l'image",
  },
  security: {
    changePassword: 'Modifier mon mot de passe',
    currentPassword: 'Votre mot de passe actuel',
    newPassword: 'Votre nouveau mot de passe',
    twoFA: 'Authentification à deux facteurs',
    activated: 'Activée',
    deactivated: 'Désactivée',
    phone: 'Votre numéro de téléphone',
    confirmPhone: 'Confirmer votre numéro de téléphone',
  },
  save: 'Enregistrer',
  industryAddedSuccess: 'Secteur ajouté !',
  industryAddError: "Impossible d'ajouter le secteur.",
  childQuoteOfferPending: 'En attente',
} as const;
